function setActiveTab() {
  const currentPath = window.location.pathname;

  const tabs = document.querySelectorAll('.tab');

  tabs.forEach((tab) => {
    if (tab.getAttribute('href') === currentPath) {
      tab.classList.add('active');
    } else {
      tab.classList.remove('active');
    }
    tab.addEventListener('click', function (event) {
      event.preventDefault();

      tabs.forEach((t) => t.classList.remove('active'));

      this.classList.add('active');

      window.location.href = this.href;
    });
  });
}

// TDOD: NEED TO MAKE HOOK for SULGIFY SCHEME NAME FURTHER
function standardizeToSlug(name) {
  if (typeof name !== 'string') return name;
  name = name.toLowerCase();
  const sanitizedSlug = name
    .replace(/[\s<>#%"{}\|\\^[\]()"`!_;/?:@&=+$,."]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .replace("'", '');

  return sanitizedSlug;
}

setActiveTab();
let currentPage = 2;
let lastClickedButton = document.getElementById('returns-filter-arrow');
const viewmoreBtn = document.querySelectorAll('#view-more-btn');

const mf_fetch_data = (sorting, order, pagination, view_more_flag) => {
  if (apiURL) {
    const paginatedUrl = `${apiURL}&sortby=${sorting}&orderby=${order}&pagination=${pagination}`;

    fetch(paginatedUrl)
      .then((response) => response.json())
      .then((data) => {
        if (data.data && data.data.length > 0) {
          appendDataRows(data.data, view_more_flag);
          currentPage++;
        } else {
          viewmoreBtn.forEach((vmButton) => {
            vmButton.style.display = 'none';
            const noMoreFundsMsg = document.createElement('p');
            noMoreFundsMsg.textContent = 'No more Schemes available';
            noMoreFundsMsg.style.textAlign = 'center';
            noMoreFundsMsg.style.margin = '20px';
            vmButton.parentNode.appendChild(noMoreFundsMsg);
          });
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }
};

const appendDataRows = function (records, view_more_flag) {
  const tableBody = document.querySelector('table tbody');
  const mobileContent = document.querySelector('.mobile-content');
  if (view_more_flag) {
    tableBody.innerHTML = '';
    mobileContent.innerHTML = '';
  }
  records.forEach((record) => {
    const newRow = document.createElement('tr');

    const logoUrl = `http://torusapis.cmots.com/complogodata/mf/${record.mfCoCode}.png`;
    let returns_amount;
    let returns_year;
    const returns_filter = document.getElementById('returns-filter-arrow');
    if (returns_filter.dataset.sorttype === '1YEAR') {
      returns_amount = record.oneYear;
      returns_year = '1Y returns';
    } else if (returns_filter.dataset.sorttype === '3YEAR') {
      returns_amount = record.threeYear;
      returns_year = '3Y returns';
    } else {
      returns_amount = record.fiveYear;
      returns_year = '5Y returns';
    }
    newRow.innerHTML = `
         <tr>
            <td class="first-td">
                <div class="text-img-part">
                    <div class="img-part">
                        <img
                            src="${logoUrl}"
                            alt="${record.modified_schName}" 
                            title="${record.modified_schName}" 
                            class="width--36"
                        />
                    </div>
                    <div class="text-part">
                        <a href="/mutual-funds/${standardizeToSlug(
                          record.modified_schName,
                        )}">${record.schName}</a>
                        <p>${record.category} | ${record.typename}</p>
                    </div>
                </div>
            </td>
            <td class="return">
                <span
                  data-one-year="${(record.oneYear || record.inception).toFixed(
                    2,
                  )}"
                  data-three-year="${(
                    record.threeYear || record.inception
                  ).toFixed(2)}"
                  data-five-year="${(
                    record.fiveYear || record.inception
                  ).toFixed(2)}"
                  style="color: ${returns_amount > 0 ? '#05C098' : 'red'}">
                  ${(returns_amount || record.inception).toFixed(2)}%
                </span>
            </td>
            <td>₹ ${record.minimumPurchaseAmount}</td>
            <td>₹ ${record.schemeAum.toFixed(2)}</td>
            <td><a href="/open-demat-account?query=mf&cta=invest" class="invest-btn">Invest</a></td>
          </tr>
        `;
    tableBody.appendChild(newRow);

    const mobileCard = document.createElement('div');
    mobileCard.classList.add('filter-card');
    mobileCard.innerHTML = `
            <div class="filter-top-card">
              <div class="card-img">
                <img
                  src="${logoUrl}"
                  alt="${record.modified_schName}"
                  title="${record.modified_schName}"
                  class="width--36"
                />
              </div>
              <div class="card-text">
              <a href="/mutual-funds/${standardizeToSlug(record.modified_schName)}">
                <h3>${record.schName}</h3>
              </a>
                <p class="card-text-type">
                  <span>${record.typename} <span> |
                  <span>${record.category} <span>
                </p>
              </div>
              <a href="/open-demat-account?query=mf&cta=invest">
              <button id="invest-btn-mobile-card" class="invest-btn">
              Invest
              </button>
              </a>
              </div>
            <div class="filter-bottom-card">
              <div class="return filter-bottom-card-first">
                <p>${returns_year}</p>
                <span
                  data-one-year="${(record.oneYear || record.inception).toFixed(
                    2,
                  )}"
                  data-three-year="${(
                    record.threeYear || record.inception
                  ).toFixed(2)}"
                  data-five-year="${(
                    record.fiveYear || record.inception
                  ).toFixed(2)}"
                  style="color: ${returns_amount > 0 ? '#05C098' : 'red'}">
                  ${(returns_amount || record.inception).toFixed(2)}%
                </span>
              </div>
              <div class="filter-bottom-card-first">
                <p>Min. Invest</p>
                <h4>₹${record.minimumPurchaseAmount}</h4>
              </div>
              <div class="filter-bottom-card-first">
                <p>AUM</p>
                <h4>₹${record.schemeAum.toFixed(2)}</h4>
              </div>
            </div>
        `;

    mobileContent.appendChild(mobileCard);
  });
};
const viewMoreHandler = function () {
  const viewMoreButtons = document.querySelectorAll('.view-more-btn');
  viewMoreButtons.forEach((vmButton) => {
    vmButton.addEventListener('click', function (event) {
      event.preventDefault();
      if (lastClickedButton) {
        if (!lastClickedButton.dataset.order) {
          lastClickedButton.dataset.order = 'desc';
        }
      }
      mf_fetch_data(
        lastClickedButton.dataset.sorttype,
        lastClickedButton.dataset.order,
        currentPage,
        false,
      );
    });
  });
};
viewMoreHandler();

const riskScale = {
  Low: -45,
  'Moderately Low': -22.5,
  Moderate: 0,
  'Moderately High': 22.5,
  High: 45,
  'Very High': 67.5,
};

document.addEventListener('DOMContentLoaded', function () {
  const gauges = document.querySelectorAll('.cmp-gauge');
  const riskTexts = document.querySelectorAll('.risk-text');

  gauges.forEach((gauge, index) => {
    const riskValue = gauge.getAttribute('data-risk');

    if (riskValue === 'Low' || riskValue === 'Moderately Low') {
      riskTexts[index].style.color = 'green';
    } else if (riskValue === 'Moderate' || riskValue === 'Moderately High') {
      riskTexts[index].style.color = 'orange';
    } else if (riskValue === 'High' || riskValue === 'Very High') {
      riskTexts[index].style.color = '#C43A4B';
    }

    const needle = gauge.querySelector('.needle');
    const rotationDegree = riskScale[riskValue] || 0;
    needle.style.transform = `rotate(${rotationDegree}deg)`;
    needle.style.transition = 'transform 0.5s ease';
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const filterArrows = document.querySelectorAll('.d-flex img');
  document
    .getElementById('best-performer-card')
    ?.addEventListener('click', function () {
      window.location.href = '/mutual-funds/best-performing-mutual-funds';
    });

  document
    .getElementById('index-fund-card')
    ?.addEventListener('click', function () {
      window.location.href = '/mutual-funds/index-funds';
    });

  document
    .getElementById('wealth-builder-card')
    ?.addEventListener('click', function () {
      window.location.href = '/mutual-funds/wealth-builder-funds';
    });

  document
    .getElementById('high-risk-card')
    ?.addEventListener('click', function () {
      window.location.href = '/mutual-funds/high-return-mutual-funds';
    });

  document.getElementById('nfo-card')?.addEventListener('click', function () {
    window.location.href = '/mutual-funds/nfo';
  });

  document
    .getElementById('tax-savers-card')
    ?.addEventListener('click', function () {
      window.location.href = '/mutual-funds/elss-funds';
    });

  function getCellValue(row, columnIndex) {
    const cell = row.cells[columnIndex];
    if (!cell) return 0;
    const text = cell.textContent.trim();
    let value = parseFloat(text.replace(/[^0-9.]/g, '')) || 0;
    if (text.includes('Cr')) {
      value *= 10000000;
    }
    return value;
  }

  function sortTable(columnIndex, button, returns_filter_flag = true) {
    filterArrows.forEach((img) => {
      if (img.id !== 'returns-filter-arrow-mob') {
        img.style.opacity = '0.5';
      }
    });
    let targetImage;
    if (columnIndex === 1) {
      targetImage = document.getElementById('returns-filter-arrow');
    } else {
      targetImage = button.querySelector('img');
    }
    if (targetImage) {
      targetImage.style.opacity = '1';
    }
    const tableBody = document.querySelector('tbody');
    const rows = Array.from(tableBody.querySelectorAll('tr'));
    if (rows.length === 1 && rows[0].textContent.includes('No Schemes')) {
      return;
    }
    if (button.dataset.order && returns_filter_flag) {
      const isAscending = button.dataset.order === 'asc';
      button.dataset.order = isAscending ? 'desc' : 'asc';
    } else if (!button.dataset.order) {
      button.dataset.order = 'desc';
    }
    lastClickedButton = button;
    currentPage = 1;
    mf_fetch_data(
      button.dataset.sorttype,
      button.dataset.order,
      currentPage,
      true,
    );
  }
  const returns_filter = document.getElementById('returns-filter-arrow');
  const invest_filter = document.getElementById('invest-filter-arrow');
  const aum_filter = document.getElementById('aum-filter-arrow');
  const return_toggle = document.getElementById('toggle-period-btn');
  const returns_filter_mob = document.getElementById(
    'returns-filter-arrow-mob',
  );
  const return_toggle_mob = document.getElementById('toggle-period-btn-mob');
  if (returns_filter_mob) {
    returns_filter_mob.addEventListener('click', function () {
      sortTable(1, returns_filter);
    });
  }
  if (return_toggle && returns_filter) {
    return_toggle?.addEventListener('click', function () {
      if (returns_filter.dataset.sorttype === '1YEAR') {
        returns_filter.dataset.sorttype = '3YEAR';
        document
          .querySelectorAll('.current-period')
          .forEach((label) => (label.innerText = '3Y returns'));
      } else if (returns_filter.dataset.sorttype === '3YEAR') {
        returns_filter.dataset.sorttype = '5YEAR';
        document
          .querySelectorAll('.current-period')
          .forEach((label) => (label.innerText = '5Y returns'));
      } else {
        returns_filter.dataset.sorttype = '1YEAR';
        document
          .querySelectorAll('.current-period')
          .forEach((label) => (label.innerText = '1Y returns'));
      }
      sortTable(1, returns_filter, false);
    });
  }
  if (return_toggle_mob && returns_filter) {
    return_toggle_mob?.addEventListener('click', function () {
      if (returns_filter.dataset.sorttype === '1YEAR') {
        returns_filter.dataset.sorttype = '3YEAR';
        document
          .querySelectorAll('.current-period')
          .forEach((label) => (label.innerText = '3Y returns'));
      } else if (returns_filter.dataset.sorttype === '3YEAR') {
        returns_filter.dataset.sorttype = '5YEAR';
        document
          .querySelectorAll('.current-period')
          .forEach((label) => (label.innerText = '5Y returns'));
      } else {
        returns_filter.dataset.sorttype = '1YEAR';
        document
          .querySelectorAll('.current-period')
          .forEach((label) => (label.innerText = '1Y returns'));
      }
      sortTable(1, returns_filter, false);
    });
  }
  if (returns_filter) {
    returns_filter.dataset.sorttype = '1YEAR';
    returns_filter?.addEventListener('click', function () {
      sortTable(1, this);
    });
  }
  if (invest_filter) {
    invest_filter.dataset.sorttype = 'Minimum Purchase Amount';
    invest_filter?.addEventListener('click', function () {
      sortTable(2, this);
    });
  }
  if (aum_filter) {
    aum_filter.dataset.sorttype = 'SchemeAUM';
    aum_filter?.addEventListener('click', function () {
      sortTable(3, this);
    });
  }
});
